import React, { useState, useEffect } from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { Icon } from '@ui-kitten/components'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import DeleteConfirmationModal from './DeleteConfirmationModal'
import { useColors } from '../utils/useColors'

export default function UniversalDetailScreen({
  navigation,
  title,
  onDelete,
  children
}) {
  const colors = useColors()
  const [deleteConfirmModalVisible, setDeleteConfirmModalVisible] = useState(false)

  useEffect(() => {
    // Set up delete button if onDelete is provided
    if (onDelete) {
      navigation.setOptions({
        headerRight: () => (
          <TouchableOpacity
            onPress={() => setDeleteConfirmModalVisible(true)}
            style={{ marginRight: 15 }}
          >
            <Icon name='trash-outline' width={24} height={24} fill={colors.danger} />
          </TouchableOpacity>
        ),
        title
      });
    } else {
      navigation.setOptions({
        title
      });
    }
  }, [navigation, title, onDelete]);

  const handleDelete = async () => {
    try {
      await onDelete();
      navigation.goBack();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <KeyboardAwareScrollView 
      style={styles.container} 
      keyboardShouldPersistTaps='handled' 
      keyboardDismissMode='none'
      extraHeight={100}
    >
      {children}

      {/* Spacer at bottom */}
      <View style={{ height: 100 }}></View>

      {/* Delete confirmation modal */}
      <DeleteConfirmationModal
        visible={deleteConfirmModalVisible}
        onCancel={() => setDeleteConfirmModalVisible(false)}
        onConfirm={handleDelete}
      />
    </KeyboardAwareScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 20,
  }
}); 